import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Navbar.css";

import logoWhite from "../../assests/images/Logo-White.png.png";
import logoBlack from "../../assests/images/Logo-Black.png.png";

function Navbar() {
  const closeMenu = () => {
    const navbar = document.getElementById("navbarNav");

    if (navbar.classList.contains("show")) {
      navbar.classList.remove("show");
    }
  };
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  const location = useLocation();

  const transparentPages = ["/about", "/services", "/contact", "/areas"];

  const isHeroPage = transparentPages.includes(location.pathname);

  const isMobile = window.innerWidth <= 991;

  const isTransparent = !isMobile && isHeroPage && !isScrolled;
  useEffect(() => {
    const controlNavbar = () => {
      setIsScrolled(window.scrollY > 400);
      if (window.scrollY <= 50) {
        setShowNavbar(true);
      } else if (window.scrollY > lastScrollY) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }

      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", controlNavbar);

    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, [lastScrollY]);

  return (
    <nav
      className={`navbar navbar-expand-lg ${
        isTransparent ? "navbar-transparent" : "navbar-solid"
      } ${showNavbar ? "navbar-show" : "navbar-hide"}`}
    >
      <div className="container">
        {/* Logo */}
        <NavLink className="navbar-brand" to="/">
          <img
            src={!isMobile && isTransparent ? logoWhite : logoBlack}
            alt="MR Mob Fixer"
            className="navbar-logo"
          />
        </NavLink>

        {/* Mobile Menu Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto align-items-lg-center">
            <li className="nav-item">
              <NavLink
                to="/"
                onClick={closeMenu}
                className={({ isActive }) =>
                  isActive ? "nav-link active-link" : "nav-link"
                }
              >
                Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/about"
                onClick={closeMenu}
                className={({ isActive }) =>
                  isActive ? "nav-link active-link" : "nav-link"
                }
              >
                About Us
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/services"
                onClick={closeMenu}
                className={({ isActive }) =>
                  isActive ? "nav-link active-link" : "nav-link"
                }
              >
                Services
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/contact"
                onClick={closeMenu}
                className={({ isActive }) =>
                  isActive ? "nav-link active-link" : "nav-link"
                }
              >
                Contact
              </NavLink>
            </li>

            <li className="nav-item ms-lg-3 mt-3 mt-lg-0">
              <a href="tel:+971500000000" className="btn call-btn">
                Call Now
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
